import { render, staticRenderFns } from "./GenduAssess2.vue?vue&type=template&id=c3fc008c&scoped=true&"
import script from "./GenduAssess2.vue?vue&type=script&lang=js&"
export * from "./GenduAssess2.vue?vue&type=script&lang=js&"
import style0 from "./GenduAssess2.vue?vue&type=style&index=0&id=c3fc008c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fc008c",
  null
  
)

export default component.exports